<script>
  import BaseHeading from '../BaseHeading/BaseHeading.svelte';
  import BaseLink from '../BaseLink/BaseLink.svelte';
  import { SPRITESHEET_URL } from '../../utils/constants.ts';

  let {
    headingText = undefined,
    headingLevel = 'h2',
    pharmacies,
    initialLimit = 10,
    locationsTemplate,
    showMoreText,
    showLessText,
    dataTestId = 'additional-pharmacies-list',
  } = $props();

  let expanded = $state(false);
  const toggle = () => (expanded = !expanded);
</script>

<section data-testid={dataTestId} class="max-w-6xl mx-auto bg-white anchor-none">
  {#if headingText}
    <BaseHeading
      className="text-blue-dark-navy font-semibold text-base leading-tight md:text-lg md:leading-snug mb-2 p-4 pt-6
      md:py-12 lg:py-16 mx-auto max-w-sm md:text-center"
      {headingLevel}
    >
      {headingText}
    </BaseHeading>
  {/if}
  <ul class="sm:grid sm:grid-cols-2 sm:gap-4 lg:grid-cols-3 xl:gap-8 w-full sm:px-4 md:px-8 xl:px-4">
    {#each pharmacies as { name, count, link }, i (i)}
      <li
        data-testid="additional-pharmacies-list-item-{i}"
        class="justify-between items-baseline w-full px-4 lg:px-6 shadow-y-sm bg-white text-blue-navy"
        class:flex={expanded || i < initialLimit}
        class:hidden={!expanded && i >= initialLimit}
      >
        {#if link && link.url}
          <BaseLink
            {...link}
            className="py-3 pr-4 lg:py-6 w-full hover-hover:hover:text-blue-cerulean active:text-blue-cerulean"
            dataTestId="{dataTestId}-link-tile-{i}"
          >
            <span class="text-lg xl:text-1.5xl leading-normal">{name}</span>
            {#if count}
              <span
                class="flex-none py-5 lg:py-7 text-gray-charcoal text-sm lg:text-xl"
                dataTestId="additional-pharmacies-list-item-count-{i}"
              >
                {locationsTemplate.replace(/{{COUNT}}/, count)}
              </span>
            {/if}
          </BaseLink>
        {:else}
          <span class="py-3 pr-4 lg:py-6 text-lg xl:text-1.5xl leading-normal">{name}</span>
          {#if count}
            <span
              class="flex-none py-5 lg:py-7 text-gray-charcoal text-sm xl:text-1.5xl"
              dataTestId="additional-pharmacies-list-item-count-{i}"
            >
              {locationsTemplate.replace(/{{COUNT}}/, count)}
            </span>
          {/if}
        {/if}
      </li>
    {/each}
  </ul>
  {#if pharmacies.length > initialLimit}
    <button onclick={toggle} class="block my-10 lg:my-18 mx-auto group" data-testid="additional-pharmacies-show-more">
      <div
        class="flex items-center text-xs leading-relaxed font-semibold text-blue-cerulean hover-hover:hover:text-blue-darkish hover-hover:hover:underline active:underline active:text-blue-darkish"
      >
        <svg role="presentation" class="w-4 h-4 inline mr-2 fill-current">
          <use xlink:href="{SPRITESHEET_URL}#{!expanded ? 'plus-sign' : 'minus-sign'}" />
        </svg>
        <span>{!expanded ? showMoreText : showLessText}</span>
      </div>
    </button>
  {/if}
</section>
